import "./style.css";

interface OverlayProps {
	product: string | undefined;
}

export const OverlayLoader = (props: OverlayProps) => (
	<div className="overlay-content">
		<div className="bg-white text-blues-ink rounded lg:w-[30%] h-auto px-6 py-4 text-center sm:text-base sm:p-2 sm:m-4 sm:mr-4 sm:ml-4 sm:w-auto md:p-4 md:m-8 md:mr-8 md:ml-8 md:w-auto">
			<div className="text-blues-ink font-bold w-full py-2 text-2xl">Processing...</div>
			<div className="inline-block h-6 w-6 mt-1 animate-spin rounded-full border-4 border-solid border-current border-white border-b-grey-scale-blue-grey-100 align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite]" />
			<div className="text-lg font-semibold py-2 px-6">You have selected the "{props?.product}" package</div>
			<div className="text-sm text-grey-scale-slate py-2 px-8">
				Thank you for your patience. Your order is currently being processed and you are being taken to check out.
			</div>
		</div>
	</div>
);
